(function (app, ng) {
    app.directive("figTooltipContainer", [function () {
        return {
            scope: { condition: "=figTooltipContainer", text: "@figTooltipText" },
            controllerAs: "tooltipCtrl",
            bindToController: true,
            controller: [function() {}]
        };
    }]);

    app.directive("figTooltip", [function () {
        return {
            require: ["^figTooltipContainer"],
            link: function (scope, elem, attr, ctrls) {
                var tooltipCtrl = ctrls[0];

                var tooltip = ng.element(document.createElement("span"));
                window.tooltip = tooltip;
                window.elem = elem;

                tooltip.addClass("fig-tooltip");
                tooltip.text(tooltipCtrl.text);

                elem.on("mouseenter", function (ev) {
                    if (!tooltipCtrl.condition) return;

                    elem.append(tooltip);
                });

                elem.on("mousemove", function (ev) {
                    if (!tooltipCtrl.condition) return;

                    var x = ev.clientX,
                        y = ev.clientY;

                    tooltip[0].style.top = (y + 20) + "px";
                    tooltip[0].style.left = (x + 20) + "px";
                });

                elem.on("mouseleave", function () {
                    if (!tooltipCtrl.condition) return;

                    tooltip.remove();
                });
            }
        };
    }]);
})(window.app, window.angular); // jshint ignore:line